const initDrag = (containerSelector, dragSelector, targetSelector, curseSelector, dragStart, dragEnd) => {

  let containerElm = null; // 容器玄素
  let containerRect = null; // 容器左，上，右和下分别相对浏览器视窗的位置
  let dragElms = null; // 可以拖动得元素
  let targetElms = null; // 可以移动进入得元素
  let curseElm = null; // 跟随鼠标移动得元素
  let moveElm = null; // 选中得元素
  let targetElm = null;	// 是否允许移动标识
  let permitDrag = false;	// 是否允许移动标识

  // 获取拖动节点
  const _getDragElm = () => {
    dragElms = document.querySelectorAll(dragSelector);
    targetElms = document.querySelectorAll(targetSelector);
    curseElm = document.querySelector(curseSelector);
  };
  // 判断是否拖动节点
  const _isDragElm = (elm) => {
    for (let i = 0; i < dragElms.length; i++) {
      // 计算鼠标是否处理拖动元素上
      if (dragElms[i] === elm || dragElms[i].contains(elm)) {
      // 1.初始化拖动参数
        moveElm = dragElms[i];
        permitDrag = true;
      }
    }
  };
  // 获取拖动计算数据
  const _getDragConstant = ()=>{
    containerRect = containerElm.getBoundingClientRect();
  };

  // 设置拖动样式
  const _setDragStyle = (curseX, curseY) =>{
    containerElm.setAttribute('style', 'user-select: none;position:relative;-ms-user-select: none;');
    moveElm.setAttribute('style', 'background-color: #fff !important;box-shadow: inset 0px -1px 0px 0px #E9E9E9;');
    for (let t = moveElm.childNodes.length - 1; t >= 0; t--) {
      moveElm.childNodes[t].setAttribute('style', 'background-color: #fff !important;color: #8C8C8C;');
    }
    for (let t = 0; t < targetElms.length; t++) {
      targetElms[t].setAttribute('style', 'pointer-events: none;');
    }

    const left = curseX - containerRect.left;
    const top = curseY - containerRect.top;
    curseElm.setAttribute('style', `left: ${left}px;top: ${top}px;opacity: 1;`);
  };

  // 重置样式
  const _resetDragStyle = ()=>{

    containerElm.removeAttribute('style');
    moveElm.removeAttribute('style');
    curseElm.removeAttribute('style');
    for (let t = moveElm.childNodes.length - 1; t >= 0; t--) {
      moveElm.childNodes[t].removeAttribute('style');
    }
    for (let t = 0; t < targetElms.length; t++) {
      targetElms[t].removeAttribute('style');
    }
  };

  // 清除变更量
  const _resetDragConstant = ()=>{
    containerRect = null; // 容器左，上，右和下分别相对浏览器视窗的位置
    dragElms = null; // 可以拖动得元素
    targetElms = null; // 可以移动进入得元素
    curseElm = null; // 跟随鼠标移动得元素
    moveElm = null; // 选中得元素
    targetElm = null;	// 是否允许移动标识
    permitDrag = false;	// 是否允许移动标识
  };
  // 计算鼠标节点位置
  const _setCursePosition = (curseX, curseY) =>{

    let x = curseX - containerRect.left;
    let y = curseY - containerRect.top;
    const maxL = containerElm.offsetWidth - curseElm.offsetWidth;
    const maxT = containerElm.offsetHeight - curseElm.offsetHeight;

    // 不允许超出容器范围
    x = x < 0 ? 0 : x;
    x = x > maxL ? maxL : x;
    y = y < 0 ? 0 : y;
    y = y > maxT ? maxT : y;

    // 3.修改鼠标节点的坐标
    curseElm.setAttribute('style', `left: ${x}px;top: ${y}px;opacity: 1;`);
  };

  const _setTargetStyle = (curseX, curseY)=>{
    let x = curseX - containerRect.left;
    let y = curseY - containerRect.top;
    let currentElm = null;
    for (let i = 0;i < targetElms.length; i++) {

      const elRect = targetElms[i].getBoundingClientRect();
      // 获取容器的坐标范围 (区域)
      var box_x = elRect.left - containerRect.left; // 容器左上角x坐标
      var box_y = elRect.top - containerRect.top;// 容器左上角y坐标
      var box_width = targetElms[i].offsetWidth; // 容器宽
      var box_height = targetElms[i].offsetHeight; // 容器高

      if (x > box_x && x < box_x - 0 + box_width && y > box_y && y < box_y - 0 + box_height) {
        currentElm = targetElms[i];
        // 给可以放置的容器加背景色
        targetElms[i].setAttribute('style', 'background-color: #F0F6FF !important;');
      } else {
        // 恢复容器原背景色
        targetElms[i].removeAttribute('style');
      }
    }
    targetElm = currentElm;
  };

  const _getDragValue = (elm)=>{
    let val = elm.getAttribute('drag-value');
    if (!val) {
      const cElm = elm.querySelector('.drag-value');
      cElm && (val = cElm.value);
    }
    return val;
  };

  let timer = null;
  const longPress = (elm, callback) =>{
    elm.addEventListener('mousedown', (e)=>{
      timer = setTimeout(() => {
        callback(e);
      }, 300);
    });
  };

  const outContainerListener = (() =>{
    let listener = false;
    return (callBack)=>{
      if (!listener) {
        listener = true;
        document.body.addEventListener('mouseup', ()=>{
          callBack();
        });
        window.addEventListener('blur', ()=>{
          callBack();
        });
      }
    };
  })();
  // 初始化拖动
  const _init = () => {
    containerElm = document.querySelector(containerSelector);
    if (!containerElm) {
      console.error('container is must exist,and only one!');
    }
    // 长按容器
    longPress(containerElm, (event)=>{
      // 动态获取节点
      _getDragElm();
      // 开始拖动
      const e = event || window.event;
      const currentElm = e.target;
      const curseX = e.pageX;
      const curseY = e.pageY;
      _isDragElm(currentElm);
      if (permitDrag) {
        try {
          dragStart && dragStart(_getDragValue(moveElm));
        } catch (e) {
          console.error(e);
        } finally {
          // 获取拖动计算数据
          _getDragConstant();
          // 设置拖动样式
          _setDragStyle(curseX, curseY);
        }
      }
    });

    // 鼠标拖动
    containerElm.addEventListener('mousemove', (event)=>{
      if (!permitDrag) {
        return;
      }

      const e = event || window.event;
      const curseX = e.pageX;
      const curseY = e.pageY;
      // 计算鼠标坐标
      _setCursePosition(curseX, curseY);

      // 计算鼠标位置是否进入目标元素
      _setTargetStyle(curseX, curseY);
    });
    const endDrag = ()=>{
      clearTimeout(timer);
      // 判断拖拽标识是否为允许，否则不进行操作
      if (!permitDrag) return false;
      try {
        // 拖拽结束后恢复标识到初始状态
        const targetValue = targetElm ? _getDragValue(targetElm) : null;
        const moveValue = moveElm ? _getDragValue(moveElm) : null;
        dragEnd && dragEnd(targetValue, moveValue);
      } finally {
        // 执行拖拽结束后的操作
        _resetDragStyle();
        _resetDragConstant();
        return false;
      }
    };
    // 鼠标松开
    containerElm.addEventListener('mouseup', (e)=>{
      e.stopPropagation();
      endDrag();
    });

    // 容器外部事件
    outContainerListener(endDrag);

    return destroyed;
  };

  const destroyed = () => {
    containerElm = null;
  };

  _init();

};
export {
  initDrag
};
